import { matchPath } from 'react-router-dom'
import { Site } from '@envato/foundation-types'
import { IFlatQuery } from './location/types'

import { getConfigBySite } from '../../config/sites'

interface INoIndexParam {
  name: string
  value?: string
}

const pagePathIsNonIndexedable = (path: string, site: Site) => {
  const config = getConfigBySite(site, 'noIndex.routes') || []

  return config.some((notIndexablePath: string) => {
    return (
      matchPath(path, { path: notIndexablePath, exact: true, strict: true }) !==
      null
    )
  })
}

const pageUrlHasNonIndexableParams = (
  locationParams: IFlatQuery,
  site: Site
) => {
  const allNonIndexableParams = getConfigBySite(site, 'noIndex.params') || []

  if (
    site !== Site.themeforest &&
    site !== Site.graphicriver &&
    locationParams.tags
  ) {
    const notIndexedTagPairs = allNonIndexableParams.filter(
      (param: any) => param.name === 'tags'
    )

    const notIndexedTags = notIndexedTagPairs.some((param: any) => {
      const { name, value } = param
      const locationParam = locationParams[name]

      return locationParam === value || false
    })

    return !notIndexedTags
  } else {
    return allNonIndexableParams.some((param: any) => {
      const { name, value } = param
      const locationParam = locationParams[name]

      return !!locationParam && (value ? locationParam === value : true)
    })
  }
}

export const shouldPageHaveNoIndexTag = (
  locationParams: IFlatQuery,
  path: string,
  site: Site
) => {
  return (
    pagePathIsNonIndexedable(path, site) ||
    pageUrlHasNonIndexableParams(locationParams, site)
  )
}

export const getRelAttributeValue = (
  itemsCount: number,
  locationParams: IFlatQuery,
  site: Site
) => {
  const pageHasTooFewItems = itemsCount < 2
  const pageHasTooManySelectedTags =
    (locationParams.tags || '').split(',').length > 1
  const shouldLinkBeNotFollowed =
    pageHasTooFewItems ||
    pageHasTooManySelectedTags ||
    pageUrlHasNonIndexableParams(locationParams, site)

  return shouldLinkBeNotFollowed ? 'nofollow' : undefined
}
